import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { palette } from 'c1ui/theme/palette'

export const C1RadioTheme: Components<Theme>['MuiRadio'] = {
    defaultProps: {
        icon: (
            <svg width="18" height="18" viewBox="0 0 20 20">
                <circle
                    cx="10"
                    cy="10"
                    r="9"
                    fill={palette.common.white}
                    stroke={palette.grey[300]}
                    strokeWidth="1"
                />
            </svg>
        ),
        checkedIcon: (
            <svg width="18" height="18" viewBox="0 0 20 20">
                <circle
                    cx="10"
                    cy="10"
                    r="9"
                    fill={palette.common.white}
                    stroke={palette.primary.main}
                    strokeWidth="1"
                />
                <circle
                    cx="10"
                    cy="10"
                    r="5"
                    fill={palette.primary.main}
                />
            </svg>
        ),
    },
    styleOverrides: {
        root: ({ theme }) =>
            theme.unstable_sx({
                width: '36px',
                height: '36px',
                marginX: 1,
                borderRadius: C1BorderRadius.large,
                '&:hover': {
                    backgroundColor: palette.primary.extraLight,
                },
                '&:hover svg circle:first-of-type': {
                    stroke: palette.primary.main,
                },
                '&:not(.Mui-checked):hover svg circle:first-of-type': {
                    fill: 'none',
                },
                '&.Mui-disabled svg circle:first-of-type': {
                    stroke: palette.grey[500],
                    fill: 'none',
                },
                '&.Mui-disabled.Mui-checked svg circle:last-of-type': {
                    fill: palette.grey[500],
                },
            }),
    },
}
